function reorderByIndex<T>(
  itemList: Array<T>,
  oldIndex: number,
  newIndex: number,
): Array<T> {
  if (oldIndex === newIndex) {
    return itemList;
  }
  let itemMoved = itemList[oldIndex];
  if (!itemMoved) {
    return itemList;
  }
  let newList: Array<T> = [];
  if (oldIndex > newIndex) {
    for (let i = 0; i < itemList.length; i++) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      let item = itemList[i]!;
      if (i === newIndex) {
        newList.push(itemMoved);
      }
      if (i !== oldIndex) {
        newList.push(item);
      }
    }
  } else {
    for (let i = 0; i < itemList.length; i++) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      let item = itemList[i]!;
      if (i !== oldIndex) {
        newList.push(item);
      }
      if (i === newIndex) {
        newList.push(itemMoved);
      }
    }
  }
  return newList;
}

export default reorderByIndex;
